import { message } from 'antd';

export interface ToasterOptions {
  message: string;
  timeout?: number;
}

export const globalToaster = {
  success: (options: ToasterOptions) => {
    message.success(options.message, options.timeout ? options.timeout / 1000 : 3);
  },

  error: (options: ToasterOptions) => {
    message.error(options.message, options.timeout ? options.timeout / 1000 : 5);
  },

  warning: (options: ToasterOptions) => {
    message.warning(options.message, options.timeout ? options.timeout / 1000 : 4);
  },

  info: (options: ToasterOptions) => {
    message.info(options.message, options.timeout ? options.timeout / 1000 : 3);
  },

  clear: () => {
    message.destroy();
  },

  dismiss: (key: string) => {
    message.destroy(key);
  }
};
